// repository.ts
import { getApiClient } from '@mit/aws-vue';
import { TextApi } from '../api/TextApi';
import { STAGE_CONFIG } from '../config';

const textRepository = getApiClient(TextApi, 'text');

export default textRepository;

